import { ref } from 'vue'

export function useLoadingState(initialValue = false) {
  const loading = ref(initialValue)

  const setLoading = (value) => {
    loading.value = value
  }

  const withLoading = async (asyncFn) => {
    setLoading(true)
    try {
      const result = await asyncFn()
      return result
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    setLoading,
    withLoading
  }
}

